import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, jenjang = null) => {
  return http_client
    .get(
      config.apiUrl +
        'sekolah?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang ? '&jenjang=' + jenjang : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null, jenjang = null) => {
  return http_client
    .get(
      config.apiUrl +
        'sekolah/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang ? '&jenjang=' + jenjang : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'sekolah', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'sekolah/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'sekolah/' + id, data).then((response) => {
    console.log(response.data);
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'sekolah/' + id).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'sekolah/status/' + id, data).then((response) => {
    return response.data;
  });
};
const SchoolService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default SchoolService;
